export default __webpack_public_path__ + "static/media/cloud-3-night.8a340e5a.svg";